import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure } from "@nextui-org/react";
import Verify from "../Auth/verify";
import { useContext, useState } from "react";
import useAxios from '../../hooks/useAxios';
import { Authorization } from "../../providers/AuthContextProvider";

export default function VerifyModal({ setPasswordState, state, titleEn, otpCode, onOpenParentChange }) {
    const { AxiosPrivate } = useAxios()
    const { isOpen, onOpen, onOpenChange } = useDisclosure();
    const [otp, setOtp] = useState()
    const { setReload } = useContext(Authorization)

    const handleSubmit = async () => {
        if (!!setPasswordState) {
            if (otp.length == 5) {
                setPasswordState(previous => {
                    const { old_password, ...prev } = previous
                    return { password: '', password_confirmation: '', otp }
                })
                onOpenChange(false)
            }
        } else
            await AxiosPrivate.put('user/update', { [titleEn]: state, otp })
                .then(res => alert(res.data.message || 'با موفقیت ویرایش شد'))
                .catch(err => alert(err.response?.data.message || 'ویرایش نشد'))
                .finally(() => {
                    onOpenChange(false);
                    onOpenParentChange(false);
                    setReload(Math.random())
                })
    }

    return (
        <>
            {!!otpCode
                ? <div className="text-sm cursor-pointer" onClick={onOpen} title="تغییر کد تایید">
                    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm395.3 11.3l-112 112c-4.6 4.6-11.5 5.9-17.4 3.5s-9.9-8.3-9.9-14.8l0-64-96 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l96 0 0-64c0-6.5 3.9-12.3 9.9-14.8s12.9-1.1 17.4 3.5l112 112c6.2 6.2 6.2 16.4 0 22.6z"></path></svg>
                </div>
                : !!setPasswordState
                    ? <div className="text-sm text-blue-500 cursor-pointer" onClick={onOpen}>
                        رمزعبور خودرا فراموش کرده ام!
                    </div>
                    : <Button Button onPress={onOpen}>
                        ارسال کد
                    </Button >
            }
            <Modal isOpen={isOpen} onOpenChange={onOpenChange} isDismissable={false} isKeyboardDismissDisabled={true} dir="rtl">
                <ModalContent>
                    {(onClose) => (
                        <>
                            <ModalHeader className="flex flex-col gap-1"></ModalHeader>
                            <ModalBody>
                                <Verify user={state} justOtp setOtp={setOtp} />
                            </ModalBody>
                            <ModalFooter>
                                <Button color="danger" variant="light" onPress={onClose}>
                                    بستن
                                </Button>
                                <Button disabled={!!otp ? false : true} color="primary" onClick={handleSubmit}>
                                    تایید
                                </Button>
                            </ModalFooter>
                        </>
                    )}
                </ModalContent>
            </Modal>
        </>
    );
}
